var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.46978 12.4697C4.76268 12.1768 5.23755 12.1768 5.53044 12.4697L9.00011 15.9393L18.4698 6.46967C18.7627 6.17678 19.2375 6.17678 19.5304 6.46967C19.8233 6.76256 19.8233 7.23744 19.5304 7.53033L9.53044 17.5303C9.23755 17.8232 8.76268 17.8232 8.46978 17.5303L4.46978 13.5303C4.17689 13.2374 4.17689 12.7626 4.46978 12.4697Z",
    fill: "#2DB757"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.40bf3da0f8c849155da0bc9fcd03ced9.svg";
export { ForwardRef as ReactComponent };